import { useQuery } from '@tanstack/react-query';
import { IGetAllPromoCode, IGetAllPromoCodesBody } from "../../utils/types";
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const getAllPromoCodes = async (params: IGetAllPromoCodesBody) => {
  const res = await apiManager.get<IGetAllPromoCode>(
    "/admin/promoCode/all",
    params
  );
  return res;
};

export const useGetAllPromoCodes = (params: IGetAllPromoCodesBody) =>
  useQuery({
    queryKey: ["get_all_promo_codes", params],
    queryFn: async (): Promise<IGetAllPromoCode> => {
      const res = await apiClient.get(ENDPOINTS.PROMO_CODES.GET_ALL, { params });
      return res.data;
    },
  });